import { useState, useEffect, Fragment, useRef } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";
import TransferNew from "./TransferNew";
import ClientReview from "../home/ClientReview";
import InputUploader from "../../helpers/InputUploader";
import CalculateReview from "./CalculateReview";



import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";


function Transfers(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

    const [clientsCombo, setClientsCombo] = useState(null);
    const [selectedId, setSelectedId ] = useState(defId);
    const [selectedPhrase, setSelectedPhrase ] = useState("");

    const [resultTransfer, setResultTransfer ] = useState([]);
    const [resultConvert, setResultConvert] = useState([]);

    
 

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   


        fak_kontrahenci_id:  defId,   
       
        nazwa:  props.mainView.readFilter('tr_nazwa',''),   
        przypisano:  props.mainView.readFilter('tr_przypisano','_x_'),   

        nadawca:  props.mainView.readFilter('tr_nadawca',''),   

        tytul_operacji:  props.mainView.readFilter('tr_tytul_operacji',''),   
        kwota_operacji_od:  props.mainView.readFilter('tr_kwota_operacji_od',''),   
        kwota_operacji_do:  props.mainView.readFilter('tr_kwota_operacji_do',''),   

      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);


    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([        
        {
            cls:'color_deleted',
            title: 'klient nieprzypisany',
             filter: {  filed: "przypisano", set: "0", typ: "combo"  },
        },
    ]);



     const listenerSelectedId = (filedName, val, correct, msg) => 
        {
            setSelectedId(val);
        }

        const listenerSelectedPhrase = (filedName, val, correct, msg) => 
        {
            setSelectedPhrase(val);
        }


        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 5000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

                var defId = -1;
            if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

            props.mainView.writeFilter('tr_nazwa', '');
            props.mainView.writeFilter('tr_przypisano', '_x_');
            props.mainView.writeFilter('tr_nadawca', '');

            props.mainView.writeFilter('tr_tytul_operacji', '');
            props.mainView.writeFilter('tr_kwota_operacji_od', '');
            props.mainView.writeFilter('tr_kwota_operacji_do', '');
          
           
            setFilterParam({

                fak_kontrahenci_id: defId,
                nazwa: '',                 
                nadawca: '',                 
                przypisano: '_x_',                 
                tytul_operacji: '',                 
                kwota_operacji_od: '',                 
                kwota_operacji_do: '',                 
              
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_calc,transfers', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


    const getClientsCombo = () => {
        
   
        props.mainView.showProgress();    

        fetch( Config.url + '/rest_v1_home,clients_combo', {
            method: 'POST', 
            body: JSON.stringify({all:1}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();    
                 

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setClientsCombo(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();    
         });
                   

         return false;
    }
 

    const goAssign = (e) => {

       
     

        if(selectedId < 0 || selectedId == undefined)
        {
             props.mainView.showDialog( "Ups!", "Wybierz klienta" , "error" , null);  
             return;
        }
        
         setView({ v: 'list',id:-1 });

        props.mainView.showProgress();    

        fetch( Config.url + '/rest_v1_calc,transfer_assign', {
            method: 'POST', 
            body: JSON.stringify({  tem_przelewy_id: view.id,  fak_kontrahenci_id: selectedId  }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();    
                 

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {               
                        setTab(null);                          
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();    
         });
              


    }


    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });

            setSelectedPhrase('');
            setSelectedId('-1');
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }


    const showTransferForm = () => {

     if(selectedId == '_x_' || selectedId == undefined) return;

     

     console.log("sdf");
        setView({v:'new_transfer', id: selectedId});
    }


   const disconnectTransfer2 = (e)  => {

       props.mainView.showDialog( "Ups!", "Aby odpiąć przelew usuń przypisane rozliczenia. Kwota rozliczenia musi wynosić 0,00 zł" , "ok" ,  (res)=>{});
   }


   const disconnectTransfer = (e)  => {

    
        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz odpiąć klienta od tego przelewu ("+title+")" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------                        

                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_calc,transfer_disconnect', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            tem_przelewy_id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        setTab(null);//pobierz na nowo        
                                                        props.mainView.showDialog( "Sukces", "Przelew został odpięty"  , "ok" , null);                             
                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie wykonać tej operacji. Spróbuj wyzerować kwotę rozliczenia." + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                            props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );


   }

    const removeTransfer = (e)  => {

    
        var title = e.target.getAttribute('atr-title');
        var id = e.target.getAttribute('atr-id');

        props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz usunąć przelew ("+title+")" , "yesno" ,  (res)=>{

                    if(res == "yes")
                    {
                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------                        

                                 props.mainView.showProgress();       
                    

                                    fetch( Config.url + '/rest_v1_calc,transfer_remove', {
                                        method: 'POST', 
                                        body: JSON.stringify({
                                            tem_przelewy_id: id,
                                        }), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => { 

                                            props.mainView.hideProgress();    

                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                }else    
                                                {
                                                    if(res.status == 'OK')         
                                                    {       
                                                        setTab(null);//pobierz na nowo        
                                                        props.mainView.showDialog( "Sukces", "Przelew został usunięty"  , "ok" , null);                             
                                                    }else 
                                                    {
                                                        props.mainView.showDialog( "Ups!", "Nie wykonać tej operacji. Spróbuj wyzerować kwotę rozliczenia." + res.result , "error" , null);
                                                    }
                                                }
                                    } )
                                    .catch(err => {          
                                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                            props.mainView.hideProgress();    
                                    });

                                //---------------------------------------------------------------------
                                //---------------------------------------------------------------------
                    }


        } );


   }


    const completeUpload = (fileName, crypt) => {

         console.log("completeUpload " + fileName + " " + crypt);
      
         props.mainView.showProgress();


        var req = {
            crypt: crypt
        };


        fetch( Config.url + '/rest_v1_calc,parse_file', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();
                    //setView({v:'list',id:-1});

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {                   
                       setTab(null);        

                       if(res.status == 'OK')
                       {
                            var n = JSON.parse( JSON.stringify(resultTransfer) );

                            for(var u=0; u < res.result.length; u++)
                            {
                                 n.push(  JSON.parse(JSON.stringify( res.result[u]  )  )  ); 
                            }

                            setResultTransfer(n);
                       }                                                

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   
                     props.mainView.hideProgress();
                     setView({v:'list',id:-1});
         });

 
    }


    const completeUpload_k = (fileName, crypt) => {

         console.log("completeUpload " + fileName + " " + crypt);
      
         props.mainView.showProgress();


        var req = {
            crypt: crypt
        };


        fetch( Config.url + '/rest_v1_calc,convert_file', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();
                    //setView({v:'list',id:-1});

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {                   
                       setTab(null);        

                       if(res.status == 'OK')
                       {
                          var base64Data = res.result;

                          //------------------------------------------------------------
                          //------------------------------------------------------------
                        
                                    const byteCharacters = atob(base64Data);
                                    const byteNumbers = new Array(byteCharacters.length);

                                    for (let i = 0; i < byteCharacters.length; i++) {
                                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                                    }

                                    const byteArray = new Uint8Array(byteNumbers);
                                    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

                                    const url = URL.createObjectURL(blob);

                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'przelewy.mt940';

                                    document.body.appendChild(link);
                                    link.click();

                                    document.body.removeChild(link);
                                    URL.revokeObjectURL(url);

                                    setView('list');

                          //------------------------------------------------------------
                          //------------------------------------------------------------
                       }                                                

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   
                     props.mainView.hideProgress();
                     setView({v:'list',id:-1});
         });

 
    }


    const prepareImport = () => {

        setResultTransfer([]);
        setView(  {v:'new_file',id:-1} );
    }    

    const prepareConvert = () => {        

        setResultConvert([]);
        setView(  {v:'convert',id:-1} );
    }   


    const keyListener = (e) => {


                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(  code == 27 && (view.v == "assign"  || view.v == "new"  || view.v == "new_file") )  
                        {
                                setView({v:'list',id:-1});
                        }else 
                        if(  code == 13 && view.v == "assign" )                                                  
                        {                              
                                goAssign();
                        }else    
                        if(  code == 13 && view.v == "new" )                                                  
                        {                              
                               showTransferForm();
                        }else  
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                            e.target.blur();
                            filterClear();
                        }   else   
                        if(e.target.nodeName.toLowerCase() == "body" && code == 191 )                                                  
                        {
                            setView({v:'new_file',id:-1});
                        } else                      
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                           filterClear();
                        } else                                                                                          
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                            setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        } else                                                                  
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                               props.keyListener(e);
                        }

    }


   useEffect( ()=>{

            if(Config.env == "dev") console.log("Transfers.js, listener on");
            window.onkeydown = keyListener;   
                    
            
            return () => {   
                 if(Config.env == "dev") console.log("Transfers.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );


    




    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        filterClear();
        setTab(null);       
        setClientsCombo(null);
        setResultTransfer(null);       
    }



    if(tab == null)
    {
        setTab([]);
        getTab();         
        return <div>
            ...
        </div>
    }


    if(clientsCombo == null)
    {
             getClientsCombo();
    }

    
    if(view.v == "review")
    {
       // return <ClientReview userData={props.userData} mainView={props.mainView} onBack={onBack} onSuccess={onSuccess}  id={view.id}   />
    }



    
    var dialogBox = null;

    if(view.v == "assign")        
    {

        var clientFiltered = clientsCombo; 
        var selectedOneId = -1;
       
  

        if(selectedPhrase.length > 2 )
        {
            clientFiltered = new Array();

            for(var kx=0; kx < clientsCombo.length; kx++)
            {      
                if( clientsCombo[kx].title.toLowerCase().includes( selectedPhrase.toLocaleLowerCase() ) )
                {
                    clientFiltered.push(  clientsCombo[kx] );                   
                    selectedOneId = clientsCombo[kx].v;                                                         
                }
            }
        }


      
       if(clientFiltered.length == 1) {
           if(selectedId != selectedOneId )  setSelectedId(selectedOneId);
        }


        dialogBox =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Wybierz klienta</div>
                        <div className="dlg_msg" >

                        <InputText   userData={props.userData} value={selectedPhrase}   valChange={listenerSelectedPhrase} goNext={goNextNew} name="phrase" placeholder={"Nazwa / NIP: "}  className=' w250 '  />                                        
                        <InputCombo items={clientFiltered}  value={selectedId} err={null}  valChange={listenerSelectedId} goNext={null}   name={"selectedId"} placeholder={": "} className=' w300 ' req='0' firstUp="0" />
                            
                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={changeView} v="list" id="-1" >zamknij [esc]</div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div className="btn" atr-type="ok" onClick={goAssign}>gotowe [enter]</div>
                        </div>
        </div> 
    }

 
    if(view.v == "new")
    {    
          var clientFiltered = clientsCombo; 
        var selectedOneId = -1;

        if(selectedPhrase.length > 2 )
        {
            clientFiltered = new Array();

            for(var kx=0; kx < clientsCombo.length; kx++)
            {      
                if( clientsCombo[kx].title.toLowerCase().includes( selectedPhrase.toLocaleLowerCase() ) )
                {
                    clientFiltered.push(  clientsCombo[kx] );
                    selectedOneId = clientsCombo[kx].v;
                }
            }
        }

        if(clientFiltered.length == 1) {
           if(selectedId != selectedOneId)  setSelectedId(selectedOneId);
        }


        dialogBox =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Wybierz klienta</div>
                        <div className="dlg_msg" >

                   
                        <InputText   userData={props.userData} value={selectedPhrase}   valChange={listenerSelectedPhrase} goNext={goNextNew} name="phrase" placeholder={"Nazwa / NIP: "}  className=' w250 '  />                                        
                        <InputCombo items={clientFiltered}  value={selectedId} err={null}  valChange={listenerSelectedId} goNext={null}   name={"selectedId"} placeholder={": "} className=' w300 ' req='0' firstUp="0" />


                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={changeView} v="list" id="-1" >zamknij [esc]</div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div className="btn" atr-type="ok" onClick={showTransferForm}>dalej [enter]</div>
                        </div>
        </div>
 
        var defIdX = -1;
        if(props.fak_kontrahenci_id != undefined) defIdX = props.fak_kontrahenci_id;

        if(defIdX > 0)
        {
            showTransferForm();
        }
    }


    if(view.v == "new_file")
    {
       // alert("Test" + props.userData.fak_sprzedawcy_id );

        dialogBox =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Wybierz plik z komputera</div>
                        <div className="dlg_msg" >

                            <InputUploader   userData={props.userData}  typ="przelewy" typId={ -1 } remove="1" completeUpload={completeUpload} title={"kliknij tutaj i wybierz plik .CSV"} max_files="10" ext="*/*" />                               

                            {
                                resultTransfer.length > 0 &&
                                <div className="scroll200">

                                     <table className="table"  >
                                            {
                                                resultTransfer.map(  (item, ix) => {
                                                    return <tr>                                                        
                                                        <td className="gocenter">{item.data_operacji}</td>
                                                        <td className="goleft">{item.nadawca}</td>
                                                        <td className="goright"> <FormatDecimal value={item.kwota} /> </td>
                                                        <td>
                                                            {
                                                                item.res != undefined &&
                                                                <Fragment>

                                                                    {
                                                                        item.res.status == 'ERROR' &&
                                                                        <span>{item.res.param}</span>
                                                                    }

                                                                     {
                                                                        item.res.status == undefined &&
                                                                        <span>Sukces!</span>
                                                                    }

                                                                </Fragment>
                                                            }
                                                        </td>
                                                    </tr>
                                                } )
                                            }
                                     </table>

                                </div>
                            }

                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={changeView} v="list" id="-1" >zamknij [esc]</div>
              
                        </div>
        </div> 
    }

 
    if(view.v == "convert")
    {
   
        dialogBox =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Wybierz plik z komputera</div>
                        <div className="dlg_msg" >

                            <InputUploader   userData={props.userData}  typ="konwersja" typId={ -1 } remove="1" completeUpload={completeUpload_k} title={"kliknij tutaj i wybierz plik .CSV do konwersji"} max_files="1" ext="*/*" />                               

                            {
                                resultConvert.length > 0 &&
                                <div className="scroll200">

                                     <table className="table"  >
                                            {
                                                resultConvert.map(  (item, ix) => {
                                                    return <tr>                                                        
                                                        <td className="gocenter">{item.data_operacji}</td>
                                                        <td className="goleft">{item.nadawca}</td>
                                                        <td className="goright"> <FormatDecimal value={item.kwota} /> </td>
                                                        <td>
                                                            {
                                                                item.res != undefined &&
                                                                <Fragment>

                                                                    {
                                                                        item.res.status == 'ERROR' &&
                                                                        <span>{item.res.param}</span>
                                                                    }

                                                                     {
                                                                        item.res.status == undefined &&
                                                                        <span>Sukces!</span>
                                                                    }

                                                                </Fragment>
                                                            }
                                                        </td>
                                                    </tr>
                                                } )
                                            }
                                     </table>

                                </div>
                            }

                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={changeView} v="list" id="-1" >zamknij [esc]</div>
              
                        </div>
        </div> 
    }
    


    if(view.v == 'new_transfer')
    {
       return <TransferNew userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onSuccess} onSuccess={onSuccess}  id={view.id}   />
    }


    
    if(view.v == 'client')
    {
       return <ClientReview userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onSuccess} onSuccess={onSuccess}  id={view.id}   />
    }
     

    if(view.v == "calc")
    {
 
        return <CalculateReview  userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onSuccess}  onSuccess={onSuccess}  fak_kontrahenci_id={props.fak_kontrahenci_id}  id={view.id}   />
    }
   

  
        var sortList = [                          
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "data_przelewu", name: "Data przelewu"  },         
        {column: "firma_nazwa", name: "Nazwa firmy"  },
    ]


        document.title = "Przelewy bankowe" ;




    var sumKwota = 0;
    var sumRozliczono = 0;
    
    for(var k=0; k<tab.length;k++)
    {
         sumKwota = parseFloat(sumKwota) + parseFloat( tab[k].kwota );
         sumRozliczono = parseFloat(sumRozliczono) + parseFloat( tab[k].kwota_rozliczenia );
    }



    var titleRaport = "Przelewy";
        

    return  <div className="view_content">


                 
               <h3 className="dash_header">Przelewy bankowe</h3>
                              

    
               <div className="table_filter">

                        {
                            filterParam.fak_kontrahenci_id < 1 &&
                            <div className="filter_controll">   
                                                <label>Klient: </label>                             
                                                <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                            </div> 
                        }                         

                        <div className="filter_controll">   
                                            <label>Nadawca: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.nadawca}   valChange={valChangeListener} goNext={goNextNew} name="nadawca" placeholder={"Nadawca: "}   />
                        </div>  

                         <div className="filter_controll">   
                                            <label>Tytuł operacji: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.tytul_operacji}   valChange={valChangeListener} goNext={goNextNew} name="tytul_operacji" placeholder={"Nazwa: "}   />
                        </div>  


                        
                        <div className="filter_controll filter_merge">   
                            <label>Kwota operacji (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_operacji_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_operacji_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_operacji_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_operacji_do" placeholder={" "}   />
                        </div>
 

                        <div className="filter_controll">   
                                            <label>Przypisane: </label>                             
                                            <InputCombo items = { [ {v:'_x_', title: '- - -'} , {v:'1', title: 'Tak'} , {v:'0', title: 'Nie'}    ] }   userData={props.userData} value={filterParam.przypisano}   valChange={valChangeListener} goNext={goNextNew} name="przypisano" placeholder={": "}   />
                        </div>  

                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                        
                                <div className="btn" onClick={changeView} v="new" id="-1"  > Dodaj przelew [+]</div>
                                &nbsp; &nbsp;

                                {
                                     filterParam.fak_kontrahenci_id < 1 &&
                                    <div className="btn" onClick={prepareImport}   > Import z pliku [?]</div>
                                }

                                &nbsp; &nbsp;

                                {
                                   filterParam.fak_kontrahenci_id < 1 &&
                                    <div className="btn" onClick={prepareConvert }   > Konwertuj z CSV to MT940</div>
                                }
                               

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  /> 
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />


                                 &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />


                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>


               <div className="bg_center">


                        <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3>  
                                     <table className="table"  ref={tab2Ref} >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Data operacji</td>                                                                                                                                                                                              
                                                                                                                                                                                                                            
                                                <td>Klient</td>                                                                                                                                                                                              
                                                <td>Nadawca</td>                                                                                                                                                                                              
                                                <td>Tytuł</td>                                                                                                                                                                                              
                                                <td>Rodzaj transakcji</td>                                                                                                                                                                                              
                                                <td>Kwota przelewu</td>    
                                                <td className="td_right">Kwota rozliczenia</td>    
                                                                                                                            
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
 
                                                            if(row.klient.id < 0 ) rowStyle += " color_deleted "

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="gocenter">{row.data_operacji}</td>                                                                                                       
                                                                                                                                                                     
                                                                <td className="goleft">{row.klient.nazwa}</td>                                                                                                       
                                                                <td className="goleft">{row.dane_odbiorcy}</td>                                                                                                       
                                                                <td className="goleft">{row.tytul_operacji}</td>                                                                                                       
                                                                <td className="goleft">{row.rodzaj_transakcji}</td>                                                                                                       
                                                                <td className="goright" ><FormatDecimal value={row.kwota} /> </td>                                                                                                                    
                                                                <td className="goright" >
                                                                    <FormatDecimal value={row.kwota_rozliczenia} /> 
                                                                    {
                                                                        row._saldo_ != undefined &&
                                                                        <sup className="link_color" v="calc" id={row._saldo_.id} onClick={changeView} >&nbsp;[r]&nbsp;</sup>
                                                                    }
                                                                </td>      
                                                            
                                                            </tr>

                                                    } )
                                                }


                                            <tr className="">                                                                                               
                                                <td></td>                                                                                                                                                                                 
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                              
                                                <td className="gobold goright"><FormatDecimal value={sumKwota} /></td>    
                                                <td className="gobold goright"><FormatDecimal value={sumRozliczono}/></td>                                                                                                                              
                                            </tr>
                                        </tbody>

                                </table> 
                        </div>

                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Data operacji</td>                                                                                                                                                                                              
                                                <td>Data sys.</td>                                                                                                                                                                                              
                                                {
                                                                  props.fak_kontrahenci_id == undefined && 
                                                                  <td>Klient</td>
                                                }                                                                                                                                                                                                                                               
                                                <td>Nadawca</td>                                                                                                                                                                                              
                                                <td>Tytuł</td>                                                                                                                                                                                              
                                                <td>Rodzaj transakcji</td>                                                                                                                                                                                              
                                                <td>Kwota przelewu</td>    
                                                <td className="td_right">Kwota rozliczenia</td>    
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
 
                                                            if(row.klient.id < 0 ) rowStyle += " color_deleted "

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="gocenter">{row.data_operacji}</td>                                                                                                       
                                                                <td className="gocenter">{row.created_at}</td>                                                                                                       
                                                                {
                                                                  props.fak_kontrahenci_id == undefined && 
                                                                  <td className="goleft">{row.klient.nazwa}</td> 
                                                                }                                                                                                                                                                       
                                                                <td className="goleft">{row.dane_odbiorcy}</td>                                                                                                       
                                                                <td className="goleft">{row.tytul_operacji}</td>                                                                                                       
                                                                <td className="goleft">{row.rodzaj_transakcji}</td>                                                                                                       
                                                                <td className="goright" ><FormatDecimal value={row.kwota} /> </td>                                                                                                                    
                                                                <td className="goright" >
                                                                    <FormatDecimal value={row.kwota_rozliczenia} /> 
                                                                    {
                                                                        row._saldo_ != undefined &&
                                                                        <sup className="link_color" v="calc" id={row._saldo_.id} onClick={changeView} >&nbsp;[r]&nbsp;</sup>
                                                                    }
                                                                </td>      
                                                                 <MenuTable>
                                                                    <ul>

                                                                        {
                                                                            row.fak_kontrahenci_id == -1 &&
                                                                            <li v="assign" id={row.id} onClick={changeView} >Przypisz klienta</li> 
                                                                        }  

                                                                        {
                                                                            row.fak_kontrahenci_id == -1 &&
                                                                            <li atr-id={row.id} atr-title={ row.tytul_operacji +", " + row.kwota } onClick={removeTransfer} >Usuń przelew</li> 
                                                                        }   

                                                                        {
                                                                            row.fak_kontrahenci_id > 0 && row.kwota_rozliczenia == 0 &&
                                                                            <li v="disconnect" atr-id={row.id} atr-title={ row.tytul_operacji +", " + row.kwota } onClick={disconnectTransfer} >Usuń przypisanie</li> 
                                                                        } 

                                                                        {
                                                                            row.fak_kontrahenci_id > 0 && row.kwota_rozliczenia != 0 &&
                                                                            <li v="disconnect" atr-id={row.id} atr-title={ row.tytul_operacji +", " + row.kwota } onClick={disconnectTransfer2} >Usuń przypisanie</li> 
                                                                        } 

                                                                        {
                                                                            row.fak_kontrahenci_id > 0 && (props.fak_kontrahenci_id == undefined || props.fak_kontrahenci_id == -1 ) && 
                                                                            <li v="client" id={row.fak_kontrahenci_id} onClick={changeView} >Idź do klienta</li> 
                                                                        }  

                                                                    </ul>
                                                                </MenuTable>
                                                            </tr>

                                                    } )
                                                }


                                            <tr className="">                                                                                               
                                                <td></td>                                                                                                                                                                                 
                                                <td></td>                                                                                                                                                                              
                                                <td></td>                                                                                                                                                                              
                                                <td></td>                                                                                                                                                                              
                                                { props.fak_kontrahenci_id == undefined && <td>Nazwa</td>   }                                                                                                                                                                                                
                                                                                                                                                                                                                                           
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                              
                                                <td className="gobold goright"><FormatDecimal value={sumKwota} /></td>    
                                                <td className="gobold goright"><FormatDecimal value={sumRozliczono}/></td>    
                                                <td></td>                                                                                  
                                            </tr>
                                        </tbody>

                                </table>

               </div>
 
              

                              
           {dialogBox}

    </div>
}


export default Transfers;